 const QuoteReducer = (state = [], {type, load}) => {

    switch (type) {
        case  'UPDATE_QUO_API': return [...state, ...load]
         
        case 'ADD_Q': 

        return [...state, load]
          
        case 'REM_Q': return state.filter(s => s._id !== load);
          
    
        default: return state
            
    }

} 


export default QuoteReducer